// Vue Core
import Vue from 'vue';
import VueRouter from 'vue-router';

// Application
import App from './App.vue';
import { store } from './store';
import StreamX from './components/StreamX.vue';

Vue.use(VueRouter);

const routes = [
  { path: '/' },
  { path: '/stream/:id', component: StreamX, props: { default: true, sidebar: false } }
];

const router = new VueRouter({
  routes: routes, // or just routes in ES6
  mode: 'history' // do not include "#/" local tag to CLIENT-URL
})

new Vue({
  el: '#app',
  store, // ES6 style
  router: router, // or just router in ES6
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js